import DeputyCreate from './DeputyCreate.container';

export default DeputyCreate;
